import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import { InspecaoRepository } from '@data/inspecoes/inspecao.repository';
import { InspecaoModel, InspecaoModeloImpressaoModel } from '@data/inspecoes/models';
import { DetalhesInspecaoComponent } from '@modules/inspecoes/components/detalhes-inspecao/detalhes-inspecao.component';
import { ModalModelosImpressaoComponent } from '@modules/inspecoes/components/modal-modelos-impressao/modal-modelos-impressao.component';
import { InspecaoController } from '@modules/inspecoes/controllers';
import { modal } from '@shared/alerts/modal/modal.alert';
import { dateHoursFormat } from '@shared/formatters';

@Component({
  selector: 'app-inspecoes',
  templateUrl: './inspecoes.component.html',
  styleUrls: ['./inspecoes.component.scss'],
})
export class InspecoesComponent extends BaseListagemComponent<InspecaoModel> {
  filtros: Campo[] = [
    {
      name: 'numeroInspecao',
      label: 'Nº Inspeção',
      type: 'text',
      icon: 'tag',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'empresa',
      label: 'Empresa',
      type: 'text',
      icon: 'business',
      width: '25%',
      mask: '',
      validators: [],
    },
    {
      name: 'categoriaInspecao',
      label: 'Categoria Inspeção',
      type: 'text',
      icon: 'category',
      width: '25%',
      mask: '',
      validators: [],
    },
  ];

  protected acoes: Acao[] = [];

  public colunas: Coluna[] = [
    { name: 'numeroInspecao', label: 'Nº Inspeção' },
    { name: 'categoriaInspecao', label: 'Categoria Inspeção' },
    { name: 'empresa', label: 'Empresa' },
    { name: 'placa', label: 'Placa' },
    { name: 'veiculoStatus', label: 'Veículos Status' },
    { name: 'checklistStatus', label: 'Checklist Status' },
    { name: 'dataHoraInspecao', label: 'Data da Inspeção', format: dateHoursFormat },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Ver detalhes',
          icon: 'visibility',
          action: this.visualizarInspecao.bind(this),
        },
        {
          label: 'Imprimir',
          icon: 'print',
          action: this.imprimirInspecao.bind(this),
        },
      ],
    },
  ];

  constructor(
    public inspecaoController: InspecaoController,
    private inspecaoRepository: InspecaoRepository,
    private dialog: MatDialog,
  ) {
    super('Inspeções - Portal do Cliente', inspecaoController);
  }

  public visualizarInspecao(inspecao: InspecaoModel): void {
    this.dialog.open(DetalhesInspecaoComponent, {
      width: '950px',
      maxHeight: '90vh',
      data: {
        codigoInspecao: inspecao.CodigoInspecao,
        inspecao: inspecao,
      },
    });
  }

  public imprimirInspecao(inspecao: InspecaoModel): void {
    if (!inspecao?.CodigoInspecao) {
      return;
    }

    this.inspecaoRepository
      .getModelosImpressao({ limit: 100 })
      .subscribe({
        next: (response: any) => {
          const resData = response?.data || response;
          const listaModelos: InspecaoModeloImpressaoModel[] =
            resData?.results || response?.results || (Array.isArray(resData) ? resData : []);

          const codigoTipo =
            inspecao.CodigoTipoInspecaoChecklist ||
            (inspecao.TipoInspecaoChecklist as any)?.CodigoTipoInspecaoChecklist ||
            (inspecao.TipoInspecaoChecklist as any)?.Codigo ||
            (inspecao.TipoInspecaoChecklist as any)?.id;

          const modelosCompativeis = listaModelos.filter((m) => {
            if (m.Ativo && m.Ativo !== 'S') return false;

            const codigos = Array.isArray(m.CodigosTipoInspecaoChecklist)
              ? m.CodigosTipoInspecaoChecklist
              : [];

            if (codigos.length > 0) {
              return codigoTipo
                ? codigos.some((c: any) => String(c).trim() === String(codigoTipo).trim())
                : false;
            }

            // Modelo sem restrição de categoria aplica-se a todas as categorias
            return true;
          });

          if (!modelosCompativeis || modelosCompativeis.length === 0) {
            modal.fire({
              icon: 'warning',
              title: 'Atenção',
              text: 'Não foi possível imprimir pois não há layout definido.',
            });
            return;
          }

          this.dialog.open(ModalModelosImpressaoComponent, {
            width: '850px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            data: {
              inspecao,
              modelos: modelosCompativeis,
            },
          });
        },
        error: (err: any) => {
          modal.fire({
            icon: 'error',
            title: 'Erro',
            text: err?.message || 'Erro ao carregar modelos de impressão.',
          });
        },
      });
  }
}
